import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { Shareddata } from '../../providers/shareddata';
import { FuncsService } from '../../services/funcs.services';
import Masonry from 'masonry-layout';
import * as imagesLoaded from 'src/assets/js/imagesloaded.pkgd.min.js';

@Component({
	selector      : 'app-press-events',
	templateUrl   : './press-events.component.html',
	encapsulation : ViewEncapsulation.None,
	host: {
		'(window:resize)': 'onResize($event)'
	}
})

export class PressEventsComponent implements OnInit {
	@Input() pressEventsData : any;	
	public press_event_data  : any = [];

	constructor(
		private accountService : AccountServiceProvider,
		public shareddata      : Shareddata,
		private funcs          : FuncsService,
	) {
		this.funcs.globalLocalStorageHttp();
		if ( 'userData' in window.localStorage ) {		
			var userData = JSON.parse( window.localStorage.getItem( 'userData' ) );
			this.shareddata.setUserSession( userData );
		}
		this.accountService.getPressEvents().then( ( dotnetresponse: any ) => {
			if ( dotnetresponse.status == 'Ok' ) {
				this.press_event_data = dotnetresponse.programmes;
				setTimeout (
					() => {
						this.ngAfterViewInit();
					}, 100
				);
			}
		});
	}

	ngOnInit() {
		this.addMasonry();
	}

	ngAfterViewInit() {
		setTimeout (
			() => {
				this.addMasonry();
			}, 100
		);
	}

	addMasonry() {
		if ( document.querySelector( '.pe-grid' ) ) {
			var peElem = document.querySelector( '.pe-grid' );
			var peElemMsnry = new Masonry( peElem, {
				itemSelector: '.pe-grid-item',
				columnWidth: '.grid-sizer',
				horizontalOrder: true,
				percentPosition: true,
			});
			imagesLoaded( peElem ).on( 'progress', function() {
				peElemMsnry.layout();
			});
		}
	}

	onResize(event) {
		setTimeout (
			() => {
				this.ngAfterViewInit();
			}, 100
		);
	}
}